import { forwardRef } from 'react';

import type React from 'react';

type OwnProps = React.PropsWithoutRef<React.SVGProps<SVGSVGElement>>;

export default forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <svg
    width="51"
    height="39"
    viewBox="0 0 51 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-qa="dollar-bills-icon"
    ref={ref}
    {...props}
  >
    <path
      d="M7.05594 7.56494C7.05594 11.358 3.98104 14.4329 0.187958 14.4329"
      stroke="#00619E"
      strokeWidth="2"
    />
    <path
      d="M7.20933 27.9837C7.20933 24.1906 4.13443 21.1157 0.341354 21.1157"
      stroke="#00619E"
      strokeWidth="2"
    />
    <path
      d="M34.0574 21.6819C34.0574 17.8889 37.1323 14.814 40.9254 14.814"
      stroke="#00619E"
      strokeWidth="2"
    />
    <path
      d="M40.772 8.43194C36.9789 8.43194 33.904 5.35704 33.904 1.56396"
      stroke="#00619E"
      strokeWidth="2"
    />
    <path
      d="M15.1576 21.4178C13.8238 20.4537 12.7895 18.8478 12.7895 16.271C12.7895 13.6294 13.7204 11.467 15.0759 10.4145"
      stroke="#00AED9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.9761 7.74867C27.3099 8.71285 28.3441 10.3187 28.3441 12.8955C28.3441 15.5371 27.4133 17.6995 26.0577 18.752"
      stroke="#00AED9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.1907 18.3255C17.0766 18.2126 16.8256 17.7612 17.1907 17.1293C17.5558 16.4973 18.092 16.644 18.2289 16.7456C18.6169 17.0052 19.3128 17.4904 20.1685 17.4904C20.7162 17.4904 21.1155 17.1519 21.1155 16.6779C21.1155 16.1137 20.6135 15.7413 19.7007 15.3125C18.3887 14.6692 17.0538 13.947 17.0538 12.322C17.0538 10.9792 18.1149 9.625 20.2142 9.625C21.6403 9.625 22.7356 10.3472 23.1463 10.6406C23.3061 10.7309 23.2034 11.3628 22.9524 11.7014C22.7014 12.0399 22.1994 12.3672 21.9255 12.2092C21.6175 11.9948 20.8074 11.4757 20.0772 11.4757C19.5068 11.4757 19.2444 11.8255 19.2444 12.2205C19.2444 12.6719 19.7806 13.0217 20.739 13.4843C21.9484 14.0711 23.5 14.7257 23.5 16.5651C23.5 17.9643 22.2792 19.3636 20.2712 19.3636C18.4914 19.3749 17.5102 18.6414 17.1907 18.3255Z"
      fill="#00AED9"
    />
    <rect
      x="19.4436"
      y="8"
      width="1.62296"
      height="3.24998"
      rx="0.811482"
      fill="#00AED9"
    />
    <rect
      x="19.4436"
      y="17.75"
      width="1.62296"
      height="3.24998"
      rx="0.811482"
      fill="#00AED9"
    />
    <path
      d="M10.397 27.0465C5.45497 27.9412 2.39047 28.025 1.00002 27.9952V8.06126C1.00002 8.05847 1.00039 8.05787 1.00045 8.05771C1.00077 8.05694 1.00177 8.05497 1.00409 8.05254C1.00643 8.0501 1.00905 8.04831 1.01141 8.04721C1.01324 8.04636 1.01577 8.04547 1.0204 8.04524C3.06489 7.94056 8.01671 7.59428 12.8859 6.5406C16.7137 5.71227 20.1376 4.74082 23.1361 3.88382C23.2143 3.86146 23.2922 3.83918 23.3698 3.817C26.2856 2.98347 28.7549 2.27759 30.8421 1.90231C35.7014 1.02863 38.6571 0.967183 40 1.00986V21.0221L40 21.0237L39.9999 21.0241C39.9998 21.0243 39.9992 21.0255 39.9977 21.0272C39.9961 21.0289 39.9944 21.03 39.9932 21.0306C39.9925 21.0309 39.9912 21.0315 39.9878 21.0317C37.8057 21.1664 32.2388 21.5776 28.2058 22.4797C28.1223 22.4984 28.0492 22.5168 27.9663 22.54C26.7712 22.8754 14.5402 26.2965 10.397 27.0465Z"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M6.00002 30.9103V32.0588C6.00002 32.5645 6.37667 32.9819 6.88218 32.9941C8.25166 33.027 11.2443 32.9493 16.0593 32.075C20.0508 31.3503 31.7132 28.0776 32.8539 27.7565C32.9195 27.738 32.9761 27.7237 33.0426 27.7088C36.7678 26.8737 41.9396 26.4841 44.0481 26.3525C44.581 26.3193 45 25.8785 45 25.3445V6.9846C45 6.45217 44.5828 6.01442 44.0505 6.00538C43.8546 6.00206 43.6361 5.99987 43.4025 6.00001"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 35.9103V37.0588C11 37.5645 11.3767 37.9819 11.8822 37.9941C13.2517 38.027 16.2443 37.9493 21.0593 37.075C25.0508 36.3503 36.7132 33.0776 37.8539 32.7565C37.9195 32.738 37.9761 32.7237 38.0426 32.7088C41.7678 31.8737 46.9396 31.4841 49.0481 31.3525C49.581 31.3193 50 30.8785 50 30.3445V11.9846C50 11.4522 49.5828 11.0144 49.0505 11.0054C48.8546 11.0021 48.6361 10.9999 48.4025 11"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
